module.exports = __webpack_public_path__ + "img/timesheet-log-book_B09NGQXT4F.0cd248c8.jpg";